var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{attrs:{"data":_vm.data[_vm.field] || [],"columns":_vm.columns,"resizable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }